module.exports = __webpack_public_path__ + "images/instructor-bernard-marr-mobile.webp";